import './CalendarHeader.scss';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AcDialog from '../AcDialog/AcDialog';
import CalendarHeaderDate from './CalendarHeaderDate/CalendarHeaderDate';
import CalendarHeaderHoliday from './CalendarHeaderHoliday/CalendarHeaderHoliday';
import CalendarHeaderNotification from './CalendarHeaderNotification/CalendarHeaderNotification';
import CalendarHeaderSwitch from './CalendarHeaderSwitch/CalendarHeaderSwitch';
import CalendarHeaderToggle from './CalendarHeaderToggle/CalendarHeaderToggle';
import printIcon from '../../assets/images/print.svg';
import Loader from '../Loader/Loader';
import { findActiveAccounts } from '../SettingsSyncToCal/SettingsSyncToCalHelper';
import SyncToCalDialog from '../SyncToCalDialog/SyncToCalDialog';
import { useSettingsPageProvider } from '../../providers/SettingsProvider';

const CalendarHeader = ({
    actual,
    checked,
    searchDate,
    stripView,
    onHandleChange,
    onHandleChangeOfCalendar,
    onHandleCheckOfHoliday,
    onHandlePrintCalendar,
    noData
}) => {
    const history = useHistory();
    const settingsContext = useSettingsPageProvider();
    const { t } = useTranslation();

    const [errorDialog, setErrorDialog] = useState(false);
    const [openAccountLimitExceed, setAccountLimitExceedOpen] = useState(false);
    const [successMsgDetails, setSuccessMsgDetails] = useState({ emailId: '', nickName: '' });
    const [successMsgTimeOut, setSuccessMsgTimeOut] = useState(false);
    const [syncToOpen, setSyncToOpen] = useState(false);

    const accountLimitExceedClose = () => setAccountLimitExceedOpen(false);

    const handleClose = () => {
        setErrorDialog(false);
        setSyncToOpen(false);
    };

    const handleOnOpenSyncToPopUp = useCallback(async () => {
        setErrorDialog(false);
        const response = await settingsContext.getSyncedCalendarData();
        const syncedCalendarData = response['results'];
        const activeAccounts = findActiveAccounts(syncedCalendarData);
        if (activeAccounts === 6) setAccountLimitExceedOpen(true);
        else setSyncToOpen(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsContext.syncedCalendarData]);

    const handleOnTokenError = () => {
        setErrorDialog(true);
        setSyncToOpen(false);
    };

    const manageAccountBtn = () => history.push('/settings');

    const accountLimitExceedData = {
        actionLabel: t('myBlockMonth.syncToCalendar.syncCancel'),
        description: t('myBlockMonth.syncToCalendar.accountLimitExceededDesc'),
        secondaryActionLabel: t('myBlockMonth.syncToCalendar.manageAccountsBtn'),
        title: t('myBlockMonth.syncToCalendar.accountLimitExceededTitle'),
        handleAction: accountLimitExceedClose,
        handleSecondaryAction: manageAccountBtn
    };

    /* Invalid token or timeout error Dialog content */
    const errorDialogData = {
        actionLabel: t('myBlockMonth.syncToCalendar.addAccountCloseCancel'),
        description: t('myBlockMonth.syncToCalendar.addAccErrorDialogContent'),
        secondaryActionLabel: t('myBlockMonth.syncToCalendar.addAccTryAgain'),
        title: t('myBlockMonth.syncToCalendar.addAccErrorDialogHeading'),
        handleAction: handleClose,
        handleSecondaryAction:  handleOnOpenSyncToPopUp
    };

    const syncToData = {
        settingsScreen: false,
        titleMain: t('myBlockMonth.syncToCalendar.syncToCal'),
        titleSub: t('myBlockMonth.syncToCalendar.chooseCalendarType'),
        handleAction: handleClose,
        handleTokenError: handleOnTokenError,
        setSuccessMsgDetails: setSuccessMsgDetails,
        setSuccessMsgTimeOut: setSuccessMsgTimeOut
    };

    return (
        <div className="c-calendar-header">
            <div className="c-inner">
                <AcDialog
                    data={accountLimitExceedData}
                    open={openAccountLimitExceed}
                    onClose={handleClose}
                />
                {errorDialog && (
                    <AcDialog
                        data={errorDialogData}
                        open={errorDialog}
                        onClose={handleClose} 
                    />
                )}
                <SyncToCalDialog
                    data={syncToData}
                    open={syncToOpen}
                    onClose={handleClose}
                />
                <div className="c-row">
                    <CalendarHeaderSwitch
                        actual={actual}
                        onHandleChange={onHandleChange}
                    />
                    <CalendarHeaderDate 
                        noData={noData}
                        searchDate={searchDate}
                        stripView={stripView}
                    />
                    <CalendarHeaderToggle
                        onHandleChangeOfCalendar={onHandleChangeOfCalendar}
                        stripView={stripView}
                    />
                </div>
                <div className="c-row c-row--second">
                    {stripView ? (
                        <span className="label-select-event">{t('myBlockMonth.stripCalendarHeader.selectEvent')}</span>
                    )   : (
                            <CalendarHeaderHoliday
                                checked={checked}
                                onHandleCheckOfHoliday={onHandleCheckOfHoliday}
                            />
                        )
                    }
                    <div className="c-btn">
                        {!stripView && (
                            <button className="btn-sync-cal link-states" onClick={onHandlePrintCalendar}>
                                <img alt="printIcon" src={printIcon} />&nbsp;{t('myBlockMonth.stripCalendarHeader.print')}
                            </button>
                        )}
                        {settingsContext.syncToCalLoading 
                            ? <Loader /> 
                            : <button className="btn-sync-cal link-states" onClick={() => handleOnOpenSyncToPopUp()}>
                                <i className="icon-Sync-to-Calendar" ></i>&nbsp;{t('myBlockMonth.stripCalendarHeader.export')}
                              </button>
                        }
                    </div>
                </div>
                {successMsgTimeOut && <CalendarHeaderNotification successMsgDetails={successMsgDetails} />}
            </div>
        </div>
    )
}

export default CalendarHeader;